import Lookup from './lookup.js';

export default class Township extends Lookup
{

}
